import PropTypes from 'prop-types'

// Point de prélèvement en lightMode ([idStation, code, name]) renvoyé par station/pointPrel/:stationType
export const ShapePointPrelLight = PropTypes.shape({
    idStation: PropTypes.number, // Int
    typeId: PropTypes.number, // Int
    code: PropTypes.string, // Option[String]
    name: PropTypes.string, // Option[String]
})

export const ShapeSamplePoint = PropTypes.shape({
    idQualitometer: PropTypes.number.isRequired, // Double
    idPoint: PropTypes.number, // Option[Double]
    identifiant: PropTypes.string, // Option[String]
    name: PropTypes.string, // Option[String]
    startDate: PropTypes.number, // Option[DateTime]
    endDate: PropTypes.number, // Option[DateTime]
    totalLength: PropTypes.number, // Option[Double]
    xUpstream: PropTypes.number, // Option[Double]
    yUpstream: PropTypes.number, // Option[Double]
    xDownstream: PropTypes.number, // Option[Double]
    yDownstream: PropTypes.number, // Option[Double]
    mainObject: PropTypes.string, // Option[String]
    advise: PropTypes.string, // Option[String]
    x: PropTypes.number, // Option[Double]
    y: PropTypes.number, // Option[Double]
    projection: PropTypes.number, // Option[Double]
    advisedDepth: PropTypes.number, // Option[Double]
    comment: PropTypes.string, // Option[String]
    flowWidth: PropTypes.number, // Option[Double]
    photo1: PropTypes.string, // Option[String]
    photo2: PropTypes.string, // Option[String]
    photo3: PropTypes.string, // Option[String]
    photo4: PropTypes.string, // Option[String]
    photo5: PropTypes.string, // Option[String]
    photo6: PropTypes.string, // Option[String]
    startDepth: PropTypes.number, // Option[Double]
    endDepth: PropTypes.number, // Option[Double]
    codeSupport: PropTypes.number, // Option[Float]
    code: PropTypes.string, // Option[String]
    pointType: PropTypes.string, // Option[String]
})